<template>
  <el-form-item prop="productList" ref="formItem" verify class="sky-server-config">
    <div v-if="valueSize === 0">无项目设备</div>
    <div class="sky-delivery-deploy-product" v-else>
      <div class="wsp-line-height-28 wsp-border-bottom">
        <div class="wsp-display-flex">
          <div class="wsp-width-40 wsp-border-right wsp-text-align-center">产品名称</div>
          <div class="wsp-width-10 wsp-border-right wsp-text-align-center">数量</div>
          <div class="wsp-width-50 wsp-text-align-center">产品组合编码</div>
        </div>
      </div>
      <div
        v-for="(pdItem, index) in value"
        :key="index"
        :class="`wsp-line-height-28  ${index !== value.length - 1 ? 'wsp-border-bottom' : ''}`"
      >
        <div class="wsp-display-flex">
          <div class="wsp-width-40 wsp-border-right">
            <el-tag :type="dictionary['productDataType'][pdItem.dataType].tagType">{{
              dictionary['productDataType'][pdItem.dataType].label
            }}</el-tag>
            {{ pdItem.dataName }}
          </div>
          <div class="wsp-width-10 wsp-border-right wsp-text-align-center">
            {{ pdItem.num }}
          </div>
          <div class="wsp-width-50 ">{{ pdItem.dataDesc }}</div>
        </div>
      </div>
    </div>
  </el-form-item>
</template>
<script type="text/babel">
import { Popover, Input, Tag } from 'element-ui'

import dictionary from '../utils/dictionary'

export default {
  name: 'SkyDeliveryDeployProduct',
  components: {
    [Popover.name]: Popover,
    [Input.name]: Input,
    [Tag.name]: Tag
  },
  props: {
    value: {
      type: Array,
      default: function() {
        return []
      }
    },
    vmData: {
      type: Object
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  created() {
    this.valueSize = this.value.length
  },
  data() {
    return {
      valueSize: 0,
      prodcutData: [],
      dictionary: dictionary,
      productName: null
    }
  },
  watch: {
    value(value) {
      if (value) {
        this.valueSize = value.length
        this.$emit('input', this.value)
      } else {
        value = []
        this.$emit('input', this.value)
      }
    },
    vmData(data) {
      this.prodcutData = data.productList
      this.productName = data.productName
    }
  }
}
</script>
<style lang="scss">
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';

@include b(delivery-deploy-product) {
}
</style>
